import { render } from "./specialD.vue?vue&type=template&id=30ec33c3&scoped=true"
import script from "./specialD.vue?vue&type=script&lang=js"
export * from "./specialD.vue?vue&type=script&lang=js"

import "./specialD.vue?vue&type=style&index=0&id=30ec33c3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ec33c3"]])

export default __exports__